module.exports = __webpack_public_path__ + "img/tip3.58a26989.png";